import { render, staticRenderFns } from "./ExpandCard.vue?vue&type=template&id=aa38c822&scoped=true&lang=pug&"
import script from "./ExpandCard.vue?vue&type=script&lang=js&"
export * from "./ExpandCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandCard.vue?vue&type=style&index=0&id=aa38c822&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa38c822",
  null
  
)

export default component.exports